import { StrapiImageFormats, StrapiImageProps } from "@/types";
import Image from "next/image";

const StrapiImage: React.FC<StrapiImageProps> = ({ media, format = "medium", className, altText, loadingType = "lazy" }) => {
	// Fallback-Reihenfolge
	const fallbackFormats: StrapiImageFormats[] = ["xsmall", "thumbnail", "small", "medium", "large"];

	const getImageUrl = (): string => {
		if (!media.formats) return media.url;

		if (Object.prototype.hasOwnProperty.call(media.formats, format) && media.formats[format]) {
			return media.formats[format].url;
		}

		// Index des gewünschten Formats ermitteln
		const preferredIndex = fallbackFormats.indexOf(format);

		// Durch die Formate iterieren und nächstgrößeres Format suchen
		for (let i = preferredIndex; i < fallbackFormats.length; i++) {
			const fallbackFormat = media.formats[fallbackFormats[i]];
			if (fallbackFormat && fallbackFormat.url) {
				return fallbackFormat.url;
			}
		}

		// Falls alle Formate fehlen: Haupt-URL zurückgeben
		return media.url;
	};

	const imageUrl = process.env.NEXT_PUBLIC_API_ORIGIN + getImageUrl();

	return <Image priority src={imageUrl} alt={altText || media.alternativeText || media.name} className={className} width={media.width} height={media.height} />;
};

export default StrapiImage;
